import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReusableHeaderBreadcrumbContainerComponent } from ".";

@NgModule({
  declarations: [ReusableHeaderBreadcrumbContainerComponent],
  imports: [
    CommonModule
  ],
  exports: [ReusableHeaderBreadcrumbContainerComponent],
})
export class ReusableHeaderBreadcrumbContainerModule { }